import { isCustomDisplayTextLabelPart } from '@vista-digital/occ-domain';
import { getLastArrayElement } from '@vista-digital/utilities';
import { hasNewline } from './has-new-line';
export const getParagraphs = (label) => {
    const paragraphs = [{ parts: [] }];
    if (!Array.isArray(label)) {
        addPartToParagraphs(paragraphs, label);
    }
    else {
        label.forEach(part => addPartToParagraphs(paragraphs, part));
    }
    // Filter out empty paragraphs.
    return paragraphs.filter(paragraph => paragraph.parts.length);
};
const addPartToParagraphs = (paragraphs, part) => {
    if (!hasNewline(part)) {
        addPart(paragraphs, part);
    }
    else {
        if (isCustomDisplayTextLabelPart(part)) {
            addCustomDisplayTextLabelPartToParagraphs(paragraphs, part);
        }
        else {
            addStringToParagraphs(paragraphs, part);
        }
    }
};
const addStringToParagraphs = (paragraphs, text) => {
    const lines = text.split('\n');
    const lastLine = lines.reverse().shift();
    lines.reverse();
    // Add all lines but last
    lines.forEach(line => {
        addPart(paragraphs, line);
        newParagraph(paragraphs);
    });
    // Add last line
    addPart(paragraphs, lastLine);
};
const addCustomDisplayTextLabelPartToParagraphs = (paragraphs, part) => {
    part.text.split('\n').forEach(line => {
        if (!line) {
            // Indicates "\n" at start or end of text.
            newParagraph(paragraphs);
        }
        else {
            addPart(paragraphs, Object.assign(Object.assign({}, part), { text: line }));
        }
    });
};
const addPart = (paragraphs, part) => {
    if (!part)
        return;
    // Add part to last paragraph.
    getLastArrayElement(paragraphs).parts.push(part);
};
const newParagraph = (paragraphs) => {
    paragraphs.push({ parts: [] });
};
//# sourceMappingURL=get-paragraphs.js.map